module.exports = __webpack_public_path__ + "b64a21a4df94fbdc9e6e8765c2d22c54.png";